/* global window */
import { combineReducers, applyMiddleware, createStore, compose } from 'redux'
import promise from 'redux-promise'
import thunk from 'redux-thunk'
import { apiMiddleware } from 'redux-api-middleware'
import { reducer as form } from 'redux-form'
import apiAuthInjector from '../lib/apiAuthInjector'
import unauthorizedHandler from '../lib/unauthorizedHandler'
import reducers from './reducers/index'

export const STATE_HYDRATED = 'STATE_HYDRATED'

export default function configureStore(initialState) {
  const store = createStore(
    combineReducers({
      ...reducers,
      form,
    }),
    initialState,
    compose(
      applyMiddleware(
        thunk,
        promise,
        apiAuthInjector,
        apiMiddleware,
        unauthorizedHandler
      ),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  )

  store.dispatch({ type: STATE_HYDRATED, payload: store.getState() })

  return store
}
